import AreaList from "./AreaList";
import TreeList from "./TreeList";
import SensorList from "./SensorList";
import VariableList from "./VariableList";

function FilterBar({ project }) {
  // const [area, setArea];
  return (
    <div className="filter">
      <AreaList project={project} />
      <TreeList project={project} />
      <SensorList project={project} />
      <VariableList />
    </div>
  );
}

export default FilterBar;
